// import { useEffect, useState } from "react";
// import MixNumber from "./MixNumber";
import ReleaseDate from "./ReleaseDate";
import Duration from "./Duration";
import Playcount from "./Playcount";
// import Genre from "./Genre";
import FavouriteCount from "./FavouriteCount";

const archiveMix = (props) => {
  const {
    isMobile,
    index,
    mix,
    mixesData,
    activeFilter,
    drawerMix,
    setDrawerMix,
    setDrawerOpen,
  } = props;

  if (mixesData) {
    return (
      <div
        className={`archive__items-wrapper ${
          drawerMix === mix ? "active" : ""
        }`}
        onClick={() => {
          setDrawerMix(mix);
          setDrawerOpen(true);
        }}
      >
        <div className="archive__item number active">
          {activeFilter !== "mixNumber" && activeFilter !== "title" && activeFilter !== "releaseDate"?(
            `${index + 1}.  `
          ):''}
          {isMobile
            ? `RA.${mix.mixNumber < 1000?"0":""}${mix.mixNumber} ${mix.artistName}`
            : `RA.${mix.mixNumber < 1000?"0":""}${mix.mixNumber} / ${mix.artistName}`}
        </div>
        <div
          className={`archive__item duration ${
            activeFilter === "duration" ? "active" : ""
          }`}
        >
          {mix.duration ? <Duration duration={mix.duration} mix={mix} /> : ""}
        </div>
        <div
          className={`archive__item plays ${
            activeFilter === "plays" ? "active" : ""
          }`}
        >
          {mix.playbackCount ? (
            <Playcount playcount={mix.playbackCount} mix={mix} />
          ) : (
            ""
          )}
        </div>
        {/* <div
          className={`archive__item genre ${
            activeFilter === "genre" ? "active" : ""
          }`}
        >
          {mix.genre ? <Genre genre={mix.genre} mix={mix} /> : ""}
        </div> */}
        <div
          className={`archive__item likes ${
            activeFilter === "favs" ? "active" : ""
          }`}
        >
          {mix.likesCount ? <FavouriteCount favs={mix.likesCount} /> : ""}
        </div>
        <div
          className={`archive__item date ${
            activeFilter === "releaseDate" || activeFilter === "mixNumber"? "active" : ""
          }`}
        >
          {mix.releaseDate ? (
            <ReleaseDate mix={mix} date={mix.releaseDate} isMobile={isMobile}/>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  } else {
    return <div className="archive__items-wrapper">Loading...</div>;
  }
};

export default archiveMix;
